import adminApi, {
  adminAuthAPI,
  adminContactsAPI,
  adminDiscoveryAPI as baseDiscoveryAPI,
  adminReportingAPI,
  adminUsersAPI
} from '../api';

export const adminDiscoveryAPI = {
  ...baseDiscoveryAPI,
  getSdrAgentStatus: () => adminApi.get('/discovery/sdr-agent/status'),
  retryLeadSdrAgentTask: (leadId, taskId) => adminApi.post(`/discovery/leads/${leadId}/sdr-agent/tasks/${taskId}/retry`, {})
};

export { adminApi, adminAuthAPI, adminContactsAPI, adminReportingAPI, adminUsersAPI };

export default adminApi;
